
import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
  auth: {
    clientId: "55e8ce4a-2c6a-45b6-9e0a-a002db214a31",
    authority: "https://login.microsoftonline.com/b9c218d5-d804-4bbb-94b3-7db0d25a5630/v2.0",
    redirectUri: window.location.origin
  }
};

const msalInstance = new PublicClientApplication(msalConfig);

let initialized = false;

const initializeMsal = async () => {
  if (!initialized) {
    await msalInstance.initialize();
    await msalInstance.handleRedirectPromise(); // Prevent interaction_in_progress error
    initialized = true;
  }
};

export const acquireToken = async () => {

  if (process.env.NODE_ENV === 'development') {
    console.log("DEV MODE: Bypassing MSAL and returning fake token.");
    return "FAKE_ACCESS_TOKEN_FOR_DEVELOPMENT";
  }

  await initializeMsal();

  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) {
    msalInstance.loginRedirect({
      scopes: ["api://d360e088-dea0-4c51-b18d-cf41162efd0b/access_as_user"]
    });
    return null;
  }

  const response = await msalInstance.acquireTokenSilent({
    scopes: ["api://d360e088-dea0-4c51-b18d-cf41162efd0b/access_as_user"],
    account: accounts[0]
  });
  return response.accessToken;
};
